import React, { useState, useEffect } from 'react';
import wrapStore from '@src/utils/wrap-store';
import ArticleStore from './store';
import Link from '@src/components/link';
import cx from 'classnames';
import xauCss from '@src/components/xfe-animation-css';

const styles = require('./index.less');

const Article3 = ({ store }) => {
  store.use();
  const [activeAnchor, setActiveAnchor] = useState('');
  const [showSidebar, setShowSidebar] = useState(false);

  const scrollToAnchor = anchorId => {
    const element = document.getElementById(anchorId);
    if (element) {
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const offset = 50; // 向上的偏移值
      window.scrollTo({ top: elementTop - offset, behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const anchors = ['跨服拍卖', '全新诀要'];
    const handleScroll = () => {
      let currentActive = '';
      for (const id of anchors) {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200) {
            currentActive = id;
          }
        }
      }
      setActiveAnchor(currentActive);

      const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      const threshold = (960 / 192) * rootFontSize;
      setShowSidebar(window.scrollY >= threshold);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.article}>
      <div className="xfe-root-article">
        <div className={cx('xfe-layer-3', { ...xauCss.FADE.IN_UP() })} />
        <div className={cx('xfe-group-1', { ...xauCss.FADE.IN_UP() })} data-name="顶部导航条">
          <div className="xfe-layer-4" />
          <div className="xfe-group-2" data-name="组 81">
            <Link className="xfe-layer-5" data-id={'跨服拍卖'} onClick={() => scrollToAnchor('跨服拍卖')} />
            <Link className="xfe-layer-6" data-id={'全新诀要'} onClick={() => scrollToAnchor('全新诀要')} />
          </div>
        </div>

        <div className={cx('xfe-group-3', { visible: showSidebar })} data-name="侧栏导航">
          <div className="xfe-layer-7" />
          <div className="xfe-group-4" data-name="组 35">
            <Link className={cx('xfe-group-5', { active: activeAnchor === '跨服拍卖' })} data-name="跨服拍卖" onClick={() => scrollToAnchor('跨服拍卖')}>
              <div className="xfe-layer-8" />
              <div className="xfe-layer-9" />
            </Link>

            <Link className={cx('xfe-group-6', { active: activeAnchor === '全新诀要' })} data-name="全新诀要" onClick={() => scrollToAnchor('全新诀要')}>
              <div className="xfe-layer-10" />
              <div className="xfe-layer-11" />
            </Link>

            <Link className="xfe-group-7" data-name="返回顶部" onClick={scrollToTop}>
              <div className="xfe-layer-12" />
              <div className="xfe-layer-13" />
            </Link>
          </div>
        </div>
        <div className={cx('xfe-group-content', { ...xauCss.FADE.IN_DOWN() })} data-name="内容区" dangerouslySetInnerHTML={{ __html: store.content }} />
      </div>
    </div>
  );
};

export default wrapStore(Article3, ArticleStore);
